module.exports = __webpack_public_path__ + "img/p56.5bf59fbd.png";